import { render } from "./Denied.vue?vue&type=template&id=46a5f51a&scoped=true"
import script from "./Denied.vue?vue&type=script&lang=js"
export * from "./Denied.vue?vue&type=script&lang=js"

import "./Denied.vue?vue&type=style&index=0&id=46a5f51a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\60\\s\\WEPTW_Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a5f51a"]])

export default __exports__